import React, { useState } from "react";
import ForgotPasswordImage from "../assest/images/Bg_Login.jpg";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toggleModal, openModal } from "../Redux/modalSlice";
import apiInstance from "../apiConfig/apiinstance";

function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  function handleclick() {
    dispatch(openModal());
    navigate("/");
  }
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await apiInstance.post(`/api/auth/v1/forgot-password/`, {
        email,
      });

      if (response.status === 400) {
        // console.log("inside setting error");
        setError(response?.data?.errors_data?.email?.message || null);
      }
    } catch (error) {
      console.error("Error sending forgot password email:", error);
      setError(error?.response?.data?.errors_data?.email?.message || null);
    } finally {
      setSubmitted(true);
    }
  };
  

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100">
      <img
        src={ForgotPasswordImage}
        alt="login-bg"
        className="w-full h-full absolute top-0 left-0 object-cover opacity-50"
      />
      <div className="bg-white p-8 rounded shadow-md w-full max-w-sm z-10">
        <h2 className="text-2xl font-bold mb-6 text-center">Forgot Password</h2>

        {submitted ? (
          <p
            className={`text-green-600 text-center ${
              error ? "text-red-600" : ""
            }`}
          >
            {error || "A reset link has been sent to the registered email."}
          </p>
        ) : (
          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <input
              type="email"
              placeholder="Enter your registered email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="p-3 border border-gray-300 rounded"
            />
            <button
              type="submit"
              className="bg-blue-600 text-white py-3 rounded hover:bg-blue-700 transition"
            >
              Send Reset Link
            </button>
          </form>
        )}

        <div className="mt-4 text-center">
          <a
            onClick={() => handleclick()}
            className="text-sm text-blue-600 hover:underline"
          >
            Back to Login
          </a>
        </div>
      </div>
    </div>
  );
}

export default ForgotPasswordPage;
